import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Blog() {
  useEffect(() => {
    // Update page title and meta description
    document.title = 'ブログ・新着情報 - おかやまリフォーム株式会社 | 岡山市・倉敷市のリフォーム情報';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '岡山市・倉敷市のリフォーム情報をお届け。最新のリフォームトレンド、施工事例、メンテナンス情報など、おかやまリフォーム株式会社の専門知識を発信しています。');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'ブログ,リフォーム情報,施工事例,岡山市,倉敷市,新着情報,リフォームトレンド');
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/blog`);
    }

    // Schema.org JSON-LD for Blog
    const blogSchema = {
      "@context": "https://schema.org",
      "@type": "Blog",
      "name": "おかやまリフォーム株式会社ブログ",
      "description": "岡山市・倉敷市のリフォーム情報、施工事例、メンテナンス情報をお届けするブログ",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/blog`,
      "publisher": {
        "@type": "Organization",
        "name": "おかやまリフォーム株式会社"
      },
      "blogPost": [
        {
          "@type": "BlogPosting",
          "headline": "岡山市でキッチンリフォームをお考えの方へ - 2024年最新トレンド",
          "description": "キッチンリフォームの最新トレンドと、岡山市での施工事例をご紹介します。",
          "datePublished": "2024-12-15",
          "author": {
            "@type": "Organization",
            "name": "おかやまリフォーム株式会社"
          }
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'blog-schema';
    script.textContent = JSON.stringify(blogSchema);
    document.head.appendChild(script);

    return () => {
      const schemaScript = document.getElementById('blog-schema');
      if (schemaScript) schemaScript.remove();
    };
  }, []);

  const blogPosts = [
    {
      id: 1,
      title: '岡山市でキッチンリフォームをお考えの方へ - 2024年最新トレンド',
      excerpt: 'キッチンリフォームの最新トレンドと、岡山市での施工事例をご紹介します。機能性とデザイン性を両立したキッチンづくりのポイントを解説。',
      date: '2024年12月15日',
      category: 'リフォーム情報',
      image: 'https://public.readdy.ai/ai/img_res/c5465b878173f068ff67eaa10fbdf354.jpg',
      tags: ['キッチンリフォーム', '岡山市', '最新トレンド']
    },
    {
      id: 2,
      title: '倉敷市での店舗改装事例 - 古民家を活用したカフェリノベーション',
      excerpt: '倉敷市の古民家をモダンなカフェに改装した事例をご紹介。歴史ある建物の魅力を活かしながら、現代的な機能性を追加した施工のポイント。',
      date: '2024年12月10日',
      category: '施工事例',
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20house%20renovation%20into%20modern%20cafe%2C%20historic%20architecture%20with%20contemporary%20interior%2C%20wooden%20beams%2C%20modern%20lighting%2C%20comfortable%20seating%20area%2C%20cultural%20preservation&width=400&height=250&seq=blog2&orientation=landscape',
      tags: ['店舗改装', '倉敷市', '古民家リノベーション']
    },
    {
      id: 3,
      title: '冬の住宅メンテナンス - 岡山県の気候に合わせた対策法',
      excerpt: '岡山県の冬の気候特性を踏まえた住宅メンテナンスのポイントをご紹介。外壁、屋根、水回りの冬季点検項目と対策方法を詳しく解説。',
      date: '2024年12月5日',
      category: 'メンテナンス',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20house%20winter%20maintenance%2C%20professional%20inspection%20of%20roof%20and%20exterior%20walls%2C%20winter%20weather%20protection%2C%20home%20care%2C%20seasonal%20maintenance%20work&width=400&height=250&seq=blog3&orientation=landscape',
      tags: ['メンテナンス', '冬季対策', '岡山県']
    },
    {
      id: 4,
      title: 'バリアフリーリフォームの補助金制度について - 2024年度版',
      excerpt: '高齢者や身体の不自由な方のためのバリアフリーリフォーム。岡山市・倉敷市で利用できる補助金制度と申請方法をわかりやすく説明。',
      date: '2024年11月28日',
      category: 'お役立ち情報',
      image: 'https://readdy.ai/api/search-image?query=Barrier-free%20Japanese%20home%20renovation%2C%20accessible%20bathroom%20and%20entrance%2C%20handrails%2C%20wheelchair%20accessibility%2C%20universal%20design%2C%20senior-friendly%20interior&width=400&height=250&seq=blog4&orientation=landscape',
      tags: ['バリアフリー', '補助金', '岡山市', '倉敷市']
    },
    {
      id: 5,
      title: '外壁塗装の適切なタイミングと選び方 - 岡山県の気候を考慮',
      excerpt: '岡山県の気候条件に適した外壁塗装のタイミングと塗料選びのポイント。長持ちする外壁塗装のための施工時期と材料選択について。',
      date: '2024年11月20日',
      category: '外壁・屋根',
      image: 'https://readdy.ai/api/search-image?query=Professional%20exterior%20wall%20painting%20work%20on%20Japanese%20house%2C%20workers%20applying%20paint%2C%20quality%20construction%2C%20home%20improvement%2C%20building%20maintenance%2C%20fresh%20painted%20walls&width=400&height=250&seq=blog5&orientation=landscape',
      tags: ['外壁塗装', '岡山県', '塗料選び']
    },
    {
      id: 6,
      title: '水回りリフォームで快適な暮らし - 最新設備のご紹介',
      excerpt: 'キッチン、バスルーム、トイレの最新設備をご紹介。節水・省エネ機能を備えた設備で、快適性と経済性を両立したリフォーム提案。',
      date: '2024年11月15日',
      category: 'リフォーム情報',
      image: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20bathroom%20renovation%20with%20latest%20fixtures%2C%20contemporary%20design%2C%20water-saving%20features%2C%20clean%20tiles%2C%20spa-like%20atmosphere%2C%20high-quality%20materials&width=400&height=250&seq=blog6&orientation=landscape',
      tags: ['水回りリフォーム', '最新設備', '省エネ']
    }
  ];

  const categories = ['すべて', 'リフォーム情報', '施工事例', 'メンテナンス', 'お役立ち情報', '外壁・屋根'];

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative h-64 sm:h-80 md:h-96 bg-cover bg-center" style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20Japanese%20home%20renovation%20blog%20header%2C%20construction%20and%20design%20inspiration%2C%20professional%20renovation%20work%2C%20home%20improvement%20ideas%2C%20contemporary%20architecture&width=1200&height=400&seq=blog-hero&orientation=landscape')`
        }}>
          <div className="absolute inset-0 bg-black/50"></div>
          <div className="relative z-10 h-full flex items-center">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4">
                ブログ・新着情報
              </h1>
              <p className="text-base sm:text-lg md:text-xl text-white/90">
                リフォームに関する最新情報と<br className="sm:hidden" />施工事例をお届けします
              </p>
            </div>
          </div>
        </section>

        {/* Category Filter */}
        <section className="py-6 sm:py-8 bg-white border-b">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-wrap gap-2 justify-center">
              {categories.map((category, index) => (
                <button
                  key={index}
                  className={`px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    index === 0
                      ? 'bg-teal-600 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Blog Posts */}
        <section className="py-12 sm:py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              {blogPosts.map((post) => (
                <article key={post.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                  <div className="h-40 sm:h-48 overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-5 sm:p-6">
                    <div className="flex items-center justify-between mb-2 sm:mb-3">
                      <span className="bg-teal-100 text-teal-800 px-2 sm:px-3 py-0.5 sm:py-1 rounded-full text-xs font-medium">
                        {post.category}
                      </span>
                      <span className="text-xs sm:text-sm text-gray-500">{post.date}</span>
                    </div>
                    <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2 sm:mb-3 line-clamp-2">
                      {post.title}
                    </h3>
                    <p className="text-gray-600 text-xs sm:text-sm leading-relaxed mb-3 sm:mb-4 line-clamp-3">
                      {post.excerpt}
                    </p>
                    <div className="flex flex-wrap gap-1 mb-3 sm:mb-4">
                      {post.tags.map((tag, tagIndex) => (
                        <span
                          key={tagIndex}
                          className="bg-gray-100 text-gray-600 px-1.5 sm:px-2 py-0.5 sm:py-1 rounded text-xs"
                        >
                          #{tag}
                        </span>
                      ))}
                    </div>
                    <button className="text-teal-600 font-medium text-xs sm:text-sm hover:text-teal-700 transition-colors cursor-pointer">
                      続きを読む <i className="ri-arrow-right-line ml-1"></i>
                    </button>
                  </div>
                </article>
              ))}
            </div>

            {/* Pagination */}
            <div className="flex justify-center mt-8 sm:mt-12">
              <nav className="flex items-center space-x-1 sm:space-x-2">
                <button className="px-2 sm:px-3 py-2 text-gray-500 hover:text-gray-700 cursor-pointer">
                  <i className="ri-arrow-left-line text-sm sm:text-base"></i>
                </button>
                <button className="px-2.5 sm:px-3 py-2 bg-teal-600 text-white rounded cursor-pointer text-sm sm:text-base">1</button>
                <button className="px-2.5 sm:px-3 py-2 text-gray-700 hover:text-gray-900 cursor-pointer text-sm sm:text-base">2</button>
                <button className="px-2.5 sm:px-3 py-2 text-gray-700 hover:text-gray-900 cursor-pointer text-sm sm:text-base">3</button>
                <button className="px-2 sm:px-3 py-2 text-gray-500 hover:text-gray-700 cursor-pointer">
                  <i className="ri-arrow-right-line text-sm sm:text-base"></i>
                </button>
              </nav>
            </div>
          </div>
        </section>

        {/* Newsletter Subscription */}
        <section className="py-12 sm:py-16 bg-teal-600">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3 sm:mb-4">
              <strong>最新情報をお届け</strong>
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-teal-50 mb-6 sm:mb-8">
              リフォームに関する最新情報や<br className="sm:hidden" />施工事例を定期的にお届けします
            </p>
            <div className="max-w-md mx-auto">
              <form className="flex flex-col sm:flex-row gap-2">
                <input
                  type="email"
                  placeholder="メールアドレスを入力"
                  className="flex-1 px-4 py-2.5 sm:py-3 rounded-lg border-0 focus:outline-none focus:ring-2 focus:ring-teal-300 text-sm sm:text-base"
                />
                <button
                  type="submit"
                  className="bg-white text-teal-600 px-5 sm:px-6 py-2.5 sm:py-3 rounded-lg text-sm sm:text-base font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
                >
                  登録
                </button>
              </form>
              <p className="text-teal-50 text-xs mt-3">
                ※配信停止はいつでも可能です
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
